<template>
    <div>
      <h2>Reset Password</h2>
      <form @submit.prevent="resetPassword">
        <div>
          <label for="password">New Password</label>
          <input type="password" v-model="password" required />
        </div>
        <div>
          <label for="password_confirmation">Confirm Password</label>
          <input type="password" v-model="password_confirmation" required />
        </div>
        <button type="submit">Reset Password</button>
      </form>
    </div>
  </template>

  <script>
  export default {
    data() {
      return {
        password: '',
        password_confirmation: '',
        token: this.$route.query.token
      };
    },
    methods: {
      async resetPassword() {
        try {
          await axios.post('/api/auth/reset-password', {
            token: this.token,
            password: this.password,
            password_confirmation: this.password_confirmation
          });
          alert('Password has been reset successfully.');
          this.$router.push('/login');
        } catch (error) {
          console.error('Error resetting password:', error);
        }
      }
    }
  };
  </script>
